import { ArrowBackIos, Attachment, Send } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import Linkify from 'linkify-react';
import * as React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../app/store';
import makeId from '../features/makeId';
import { setLeftIsOpen, IChat, setChat } from '../features/usersSlice'
import { socket } from '../fetchoptions';
import './index.css'


type Inputs = {
	message: string,
};

export default function Chat () {
	let { active, profile, chats } = useSelector((state: RootState) => state.user);
	const dispatch = useDispatch()
	const { register, handleSubmit, reset } = useForm<Inputs>();
	const onSubmit: SubmitHandler<Inputs> = data => {
		let nChat: IChat = {
			room: active,
			id: makeId(10),
			sender: profile,
			time: JSON.stringify(new Date()),
			message: data.message
		}
		dispatch(setChat(nChat));
		socket.emit("new-chat", nChat);
		reset();
	};
	React.useEffect(() => {
		socket.on("add-chat", (chat) => {
			dispatch(setChat(chat))
			// console.log(chat);
		})
	}, [dispatch])

	React.useEffect(() => {
		document.getElementById("bottom")?.scrollIntoView({ behavior: "smooth" });
	}, [chats])

	return (
		<>
			<div className='bg-white text-slate-500 dark:text-slate-300 flex p-3 dark:bg-gray-700'>
				<span className='cursor-pointer sm:hidden my-auto' onClick={() => dispatch(setLeftIsOpen(true))}>
					<ArrowBackIos fontSize='small' />
				</span>
				<div className='ml-4 sm:ml-0 sm:w-max'>
					<h3 className='font-serif text-xl -mb-2'>{active?.name}</h3>
					<small>Created by: {active?.createdBy}</small>
				</div>
				<div className='my-auto ml-auto'>
					<small className='block -mb-2'>Room Id:</small>
					<b className=' ml-auto'>{active?.id}</b>
				</div>
			</div>

			<div className='w-full p-3 text-sm overflow-auto chat-container'>
				{chats.filter(e => e.room?.id === active?.id).map((chat, i) => (
					chat.sender?.id === profile.id ?
						<Linkify key={`chat${i}`} options={{ target: '_blank', className: 'text-blue-200' }}>
							<div className='flex w-3/4 ml-auto'>
								<div className="ml-auto">
									<div className='p-1 bg-green-600 text-white px-2 rounded break-words'>{chat.message}</div>
									<small className='pb-1 float-right'>
										{chat.time.slice(12, 20)}
									</small>
								</div>
							</div>
						</Linkify> :
						<Linkify key={`chat${i}`} options={{ target: '_blank', className: 'text-blue-400' }}>
							<div className='flex w-3/4'>
								<div className=''>
									<div className='p-1 bg-white dark:bg-slate-600 px-2 rounded break-words'>{chat.message}</div>
									<small className='p-1'>
										<b>{chat.sender?.username} </b>
										{chat.time.slice(12, 20)}
									</small>
								</div>
							</div>
						</Linkify>
				))}
				<span id="bottom"></span>
			</div>
			<div className='p-3 w-full mt-auto'>
				<form onSubmit={handleSubmit(onSubmit)} className='flex pl-4 border dark:border-0 py-1 dark:bg-slate-600  dark:focus:bg-slate-500 bg-white focus:bg-slate-100 transition rounded w-full'>
					<input {...register("message", { required: true })} className='w-full text-slate-500 text-sm dark:focus:text-slate-200 bg-transparent outline-none mr-1' placeholder='Message here' />
					<IconButton><Attachment className='text-slate-500 dark:text-slate-300' fontSize='small' /></IconButton>
					<IconButton onClick={handleSubmit(onSubmit)}><Send className='text-slate-500 dark:text-slate-300' fontSize='small' /></IconButton>
				</form>
			</div>
		</>
	)
}